var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DELETE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9647",
    "data-name": "Rechteck 9647",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_12462",
    "data-name": "Gruppe 12462"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_295",
    "data-name": "Pfad 295",
    d: "M36,12H29V7H19v5H9v2h3V41H36V14h3V12ZM21,9h6v3H21ZM34,39H14V14H34Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_296",
    "data-name": "Pfad 296",
    d: "M23,18V35h2V18H23Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_297",
    "data-name": "Pfad 297",
    d: "M18,18V35h2V18H18Z",
    fill: "#040506"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_298",
    "data-name": "Pfad 298",
    d: "M28,18V35h2V18H28Z",
    fill: "#040506"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.f71280d2b5122945fb0c780e569e4664.svg";